"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.$viewer = null;
        _this.viewerOptions = {
            backdrop: false,
            title: false,
            inline: true,
            url: 'url',
            navbar: false,
            container: '#abstract-details',
            toolbar: {
                prev: 'large',
                zoomIn: 'medium',
                oneToOne: 'medium',
                zoomOut: 'medium',
                next: 'large'
            },
            hide: function (evt) {
                _this.setCurrentSlideValue(0);
                document.querySelector('body').classList.remove('viewer-open');
            },
            view: function (evt) {
                _this.setCurrentSlideValue(evt.detail.index);
            },
            viewed: function (evt) {
                // @ts-ignore
                var offsetTop = (evt.target.viewer.canvas.offsetHeight - evt.target.viewer.imageData.height) / 2;
                offsetTop = offsetTop > 0 ? offsetTop : 0;
                // @ts-ignore
                var offsetLeft = (evt.target.viewer.canvas.offsetWidth - evt.target.viewer.imageData.width) / 2;
                offsetLeft = offsetLeft > 0 ? offsetLeft : 0;
                // @ts-ignore
                evt.target.viewer.moveTo(offsetLeft, offsetTop);
            },
        };
        _this.currentSlide = 0;
        _this.modalActive = false;
        _this.show = false;
        return _this;
    }
    Object.defineProperty(App.prototype, "images", {
        get: function () {
            return this.data.items.map(function (item, id) {
                return __assign({ id: id }, item);
            });
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.setCurrentSlideValue = function (val) {
        this.currentSlide = val;
    };
    Object.defineProperty(App.prototype, "detailsDivId", {
        get: function () {
            var _a;
            var blockTitleId = (_a = this.data.title) === null || _a === void 0 ? void 0 : _a.replace(/[^a-zA-Z0-9]/g, '_');
            return "_".concat(blockTitleId, "_abtract_images_details");
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.slideContentNotEmpty = function (slide) {
        return slide.title || slide.description;
    };
    App.prototype.toggleModal = function () {
        var body = document.querySelector("body");
        this.modalActive = !this.modalActive;
        this.show = !this.show;
        if (this.modalActive) {
            body.classList.add("modal-open");
            this.showImageGallery();
        }
        else {
            body.classList.remove("modal-open");
            this.$viewer.destroy();
        }
    };
    App.prototype.showImageGallery = function () {
        var _this = this;
        this.viewerOptions.container = "#".concat(this.detailsDivId);
        this.$nextTick(function () {
            _this.$viewer = _this.$viewerApi({
                options: _this.viewerOptions,
                images: _this.images,
            });
        });
    };
    ;
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true })
    ], App.prototype, "data", void 0);
    App = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: {},
        })
    ], App);
    return App;
}(vue_1.default));
exports.default = App;
